import type { IxcRaglV1ManualEntryKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const RAGL_MANUAL_ENTRY_BASE_PATH = getResolvedPath('/clearing/operations/journal');

export const getRaglManualEntryPath: EntityPathBuilder<IxcRaglV1ManualEntryKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return RAGL_MANUAL_ENTRY_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.entryId) {
        return undefined;
      }

      return getResolvedPath(`${RAGL_MANUAL_ENTRY_BASE_PATH}/$entryId`, context.keys);
    }
  }
};
